import { dpSelectors } from '../../../Reducers/DPReducer/dpReducer';

/* ---------------- CORE (NEW) ---------------- */

export const {
  selectOrderBookingId,
  selectSelectedShipToPartyId,
  selectCurrentCart,
  selectCurrentCartTotals,
  selectCartItemQty,
  selectTotalDPQuantity,
  selectTotalDPValue,
  selectDPDetails,
  selectIsLoading,
  selectError,
  selectPoOpenQty
} = dpSelectors;

/* ---------------- LEGACY ALIASES ---------------- */

export const selectCart = selectCurrentCart;

export const selectTotalQuantity = selectTotalDPQuantity;
export const selectTotalMT = selectTotalDPQuantity;

export const selectTotalValue = selectTotalDPValue;
export const selectGeneralCartTotalValue = selectTotalDPValue;



export const selectGeneralCart = (state) =>
  dpSelectors.selectGeneralCart(state);

export const selectShipToParty = selectSelectedShipToPartyId;

export const selectShipToPartyCarts = (state) =>
  dpSelectors.selectShipToPartyCarts(state);


/* ---------------- CATEGORY (DP SOURCE OF TRUTH) ---------------- */

export const selectSelectedCategory = (state) =>
  state.dpReducer?.dpDetails?.selectedCategory;

export const selectSelectedFormType = (state) =>
  state.dpReducer?.dpDetails?.selectedFormType;

export const selectSkuCategories = (state) =>
  state.categoryReducer?.skuCategories;

export const selectReferencePricingGeography = (state) =>
  state.dpReducer?.referencePricingGeography;

export const selectShowPriceChange = (state) =>
  state.dpReducer?.showPriceChange;

export const selectDpRouteSource = (state) =>
  state?.dpReducer?.routeSource;